const LocalStorage = {
	get(key: string): string | null {
		if (typeof window === 'undefined') {
			return null;
		}

		const item = localStorage.getItem(key);

		return item;
	},

	remove(key: string): void {
		localStorage.removeItem(key);
	},

	set(key: string, value: string | number | boolean | object) {
		const val = typeof value === 'string' ? value : JSON.stringify(value);
		localStorage.setItem(key, val);
	},

	// set a particular key in a localstorage object string
	setKeyInObjectItem(objectKey: string, data: { key: string; value: string | number | boolean | { [key: string]: any } }) {
		const { key, value } = data;
		const item = this.get(objectKey);
		let parsedItem: { [x: string]: any } = {};

		if (!item) {
			this.set(objectKey, { [key]: value });
			return;
		}

		try {
			parsedItem = JSON.parse(item);
		} catch (e) {
			throw new Error('localStorage item is not an object!');
		}

		parsedItem[key] = value;

		this.set(objectKey, parsedItem);
	},
};

export default LocalStorage;
